import { Api } from "src/core/decorators/dto/api.decorator";
import { DtoHasApi } from "../shared/dto-has-api.model";

@Api('api/app/alarms')
export class AlarmDto extends DtoHasApi {
    id: number;
    name: string;
    isActive: boolean;
}